import React from "react"
import {findDOMNode} from "react-dom"
// @ts-ignore
import SelectGenericPopoverOption from "./option/option"
import SelectGenericNew from "../select-generic-new";

const debug = false
// const debug = "SelectGenericPopoverOptionsSelector"

type Props = {
    parent                  : SelectGenericNew

    options                 : any // What is it ???

    searchString            : string

    noValueOptionLabel?     : string
    noValueOption?          : boolean   // is all values option available
    keyboardNavigation?     : boolean
    scrollToSelected?       : boolean

    popoverOptionComponent? : callback

    onUpdateScroll          : callback
}

type State = {
    currentCursorKey: any
}

export default class SelectGenericPopoverOptionsSelector extends React.Component<Props, State> {

    public optionRef            : any
    public selectedOptionRef    : any

    static defaultProps = {
        keyboardNavigation  : true
    }

    constructor(props: Props) {
        super(props)

        this.state = {
            currentCursorKey: null
        }

        // references for options for keyboard navigation
        this.optionRef = {}
    }

    componentDidMount() {
        debug && console.log(debug, "componentDidMount", this.props.scrollToSelected)
        if (this.props.scrollToSelected) {
            // setTimeout is required to call it on next frame for VScroll to finish rendering
            setTimeout(()=>{
                const node = this.selectedOptionRef ? findDOMNode(this.selectedOptionRef) : null
                if (node) this.props.onUpdateScroll(node, true)
            }, 0)
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State, snapshot: any) {
        const node = this.optionRef[this.state.currentCursorKey] ? findDOMNode(this.optionRef[this.state.currentCursorKey]) : null

        // scroll for cursor to be visible
        if (node) this.props.onUpdateScroll(node)
    }

    _getOptions = () => {
        let options = this.props.options.slice()

        // filter options by search string
        let searchString = this.props.searchString
        if (searchString) {
            searchString = searchString.toLowerCase()
            options = _(options)
                .filter(option => option.label && option.label.toLowerCase().includes(searchString))
                .value()
        }

        // add all values if necessary
        if (this.props.noValueOption) {
            options.unshift({
                isNoValueOption     : true,
                label               : this.props.noValueOptionLabel
            })
        }

        return options;
    }

    onClickOption = (option: any) => {this.props.parent.onOptionClick(option)}

    onChangeCursorOption = (newValue: any) => {
        this.setState({currentCursorKey: newValue})
    }

    onPopoverKeyDown = (event: KeyboardEvent) => {
        if (!this.props.keyboardNavigation) return

        const options = this._getOptions()

        let newValue

        switch(event.key) {
            case 'Escape':
                this.props.parent.hidePopover()
                break

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey - 1;
                    if (newValue < 0) newValue = 0
                }

                this.onChangeCursorOption(newValue)
                break

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey + 1
                    if (newValue > options.length - 1) newValue = options.length - 1
                }

                this.onChangeCursorOption(newValue)
                break

            case 'Enter':
                if (this.state.currentCursorKey !== null) {
                    const curOption = options[this.state.currentCursorKey]
                    if (curOption) this.onClickOption(curOption)
                }
                break
        }
    }

    _optionReference = (key: any, r: any, isSelected: boolean) => {
        this.optionRef[key] = r
        if (isSelected) this.selectedOptionRef = r
    }

    render() {
        const options = this._getOptions()
        const highlightedOption = options[this.state.currentCursorKey]
        const selectedOption = this.props.parent.state.currentOption

        const PopoverOption = this.props.popoverOptionComponent || SelectGenericPopoverOption

        debug && console.log(debug, "render", options)

        return (
            <React.Fragment>
                {_.map(options, (option, key)=> {
                    const isSelected = selectedOption && selectedOption.value === option.value
                    return <PopoverOption ref              = {(r: any)=>this._optionReference(key, r, isSelected)}
                                          key              = {"{0}_{1}".f(key, option.isNoValueOption ? 'all_values' : option.value)}
                                          option           = {option}
                                          isHighlighted    = {highlightedOption && highlightedOption.value === option.value}
                                          isSelected       = {isSelected}
                                          onClick          = {()=>this.onClickOption(option)}/>
                })}
            </React.Fragment>
        )
    }
}
